import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaymentService } from 'src/app/service/payment.service';
import { Payment } from '../payment/payment';

@Component({
  selector: 'app-areceber-dialog-pagamento',
  templateUrl: './areceber-dialog-pagamento.component.html',
  styleUrls: ['./areceber-dialog-pagamento.component.scss']
})
export class AreceberDialogPagamentoComponent {

  
  payments: Payment[] = [];
  troco = 0.0;

  constructor(
    public dialogRef: MatDialogRef<AreceberDialogPagamentoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private paymentService: PaymentService) {
      this.data.pago=0;
      this.data.payment=null;
      this.calc();
     }

  onCancel(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.listPayment();
  }

  listPayment() {
    this.payments.push(new Payment('DINHEIRO'));
    this.payments.push(new Payment('CARTAO'));
    this.payments.push(new Payment('PIX'));
  }
  calc() {
    
    this.troco = this.data.pago - this.data.areceberCliente.valor;
    this.data.troco = String(this.troco.toFixed(2));
  }

}
